import React, { useCallback, useContext, useState } from 'react';
import styled from 'styled-components';
import { FlexColumn, ConfirmationModal, Body, CheckBox } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useToaster from '@ubeya/shared/hooks/useToaster';

const Buttons = styled(FlexColumn)`
  align-items: flex-start;
  margin-left: -20px;
  .note {
    margin-bottom: 20px;
  }
`;

const Note = styled(Body).attrs(() => ({ className: 'note' }))`
  margin-left: 45px;
  color: ${({ theme }) => theme.colors.grey4};
`;

const InformationNote = styled(Body).attrs(() => ({ className: 'note' }))`
  margin-bottom: 8px;
`;

const TimesheetAutoFillModal = ({ onClose, data = [], autofill }) => {
  const { t } = useContext(ConfigContext);
  const [autoFillChoice, setAutoFillChoice] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const { addSuccess, addResponseError } = useToaster();

  const [scheduledHours, setScheduledHours] = useState({ override: true });

  const handleAutoFillChoiceChange = useCallback((value) => {
    setAutoFillChoice(value);
    setScheduledHours({ override: value });
  }, []);

  const onConfirm = useCallback(async () => {
    setIsLoading(true);
    try {
      await autofill({ ...data, ...scheduledHours });
      addSuccess(t(`success__update_timesheet_hours`));
    } catch (e) {
      addResponseError(e);
    } finally {
      setIsLoading(false);
      onClose();
    }
  }, [addResponseError, addSuccess, autofill, data, onClose, scheduledHours, t]);

  return (
    <ConfirmationModal
      usePortal
      onClose={onClose}
      confirmText={t('save')}
      loadingConfirm={isLoading}
      title={t('autoFillTimesheet')}
      onConfirm={onConfirm}>
      <InformationNote>{t(`autofillMultipleTimesheetsConfirmation`)}</InformationNote>
      <Buttons>
        <CheckBox
          id="scheduled"
          value={autoFillChoice}
          name="autoFillChoice"
          onChange={handleAutoFillChoiceChange}
          label={t('fillByScheduledTimes')}
        />
        <Note>{t('autoFillTimesheetAccordingToScheduledHours')}</Note>

        {autoFillChoice && (
          <CheckBox
            id="override"
            name="override"
            value={scheduledHours?.override}
            label={t('autoFillOverrideToggler')}
            onChange={(value) => setScheduledHours({ override: value })}
          />
        )}
      </Buttons>
    </ConfirmationModal>
  );
};

export default TimesheetAutoFillModal;
